import React from 'react'
import { Link } from 'react-router'
import Navigation from '@App/navigation'

interface HelpMenuPopoverProps {
    onOpenOnBoardingPopup: () => void
}

const HelpMenuPopover = (props: HelpMenuPopoverProps) => (
    <>
        <Link to={Navigation.contactUs.root()}>Contact us</Link>
        <p onClick={props.onOpenOnBoardingPopup}>View portal intro</p>
    </>
)

export default HelpMenuPopover
